/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gamecompanies_Blizzard1Inputs */

const ja_gamecompanies_blizzard1 = /** @type {(inputs: Gamecompanies_Blizzard1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activison Blizzard`)
};

const en_gamecompanies_blizzard1 = /** @type {(inputs: Gamecompanies_Blizzard1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activison Blizzard`)
};

/**
* | output |
* | --- |
* | "Activison Blizzard" |
*
* @param {Gamecompanies_Blizzard1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const gamecompanies_blizzard1 = /** @type {((inputs?: Gamecompanies_Blizzard1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gamecompanies_Blizzard1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_gamecompanies_blizzard1(inputs)
	return en_gamecompanies_blizzard1(inputs)
});
export { gamecompanies_blizzard1 as "gameCompanies_blizzard" }